define('views/blocks/ListingCartView',['jquery',
        'underscore',
        'backbone',
        'app',
        'TagCommander',
        'SubView',
        'InternalLinkView',
        'template!blocks/cart',
        'views/ui/ProductLineView',
        'views/blocks/ConsumableOptionsView',
        'views/blocks/CartCagnotteView',
        'views/blocks/CartVoucherView',
        'views/blocks/CartMinimumShippingPriceView',
        'views/blocks/FiltersView',
        'views/blocks/CartAdvantagesView',
        'views/blocks/CartVoucherPriceView',
        'views/blocks/CartExtraPriceView',
        'template!blocks/checkout/submit',
    ],
    function ($,
              _,
              Backbone,
              app,
              TagCommander,
              SubView,
              InternalLinkView,
              cartTemplate,
              ProductLineView,
              ConsumableOptionsView,
              CartCagnotteView,
              CartVoucherView,
              CartMinimumShippingPriceView,
              FiltersView,
              CartAdvantagesView,
              CartVoucherPriceView,
              CartExtraPriceView,
              submitTemplate
) {

        //
        // Listing Cart View
        // représente le bloc panier de la page Listing
        //

        return Backbone.View.extend(SubView).extend({

            events: {
                //'click .btn-consumable-options': 'openConsumableOptions',
                'click .btn-order': 'submitCart',
                'click .cart-advantages': 'openAdvantages'

            },

            initialize: function () {
                var view = this,
                    cart = app.getCart(),
                    products = cart.getProducts(),
                    ProductsIndispo = cart.getProductsIndispo();
                view.subviews = [];

                view.listenTo(app, 'resize', view.updateCartList);
                view.listenTo(app, 'listingContainerSizeChange', view.updateCartList);
                view.listenTo(cart, 'change', view.onChange);
                view.listenTo(cart, 'productsChange', view.onChange);
                view.listenTo(cart, 'start', view.onStart);
                view.listenTo(cart, 'empty', view.onEmpty);
                view.listenTo(cart, 'reorder', view.onReorder);

                view.listenTo(cart, 'changeContext', view.onChangeContext);
                view.listenTo(products, 'add', view.onAddProduct);
                view.listenTo(products, 'remove', view.updateCartList);
                view.listenTo(ProductsIndispo, 'remove', view.updateCartList);
                view.listenTo(ProductsIndispo, 'add', view.onAddProductIndispo);
                view.listenTo(app.getCustomer(), 'change:usableAdvantagesOnCart', view.onChange);

                view.render();

            },

            onStart: function (cart) {
                this.render();
                this.$('.cart-resume').html('');
            },
            onEmpty: function (cart) {
                this.render();
            },
            onChange: function (cart) {
                var view = this,
                    cart = app.getCart();
                view.$('.total-price').text(cart.formatPriceTotal());
                view.$('.total-piece').text(cart.displayPieces());
                view.renderAdvantages();
            },
            onReorder: function() {
                this.render();
            },
            renderAdvantages:function(){
                var view = this,
                    cart = app.getCart(),
                    advantagesCount = cart.getUsableAdvantages(false,true).size(),
                    advantagesAttr = {
                        "data-advantages-count":advantagesCount,
                        "data-advantages-enable":(!!advantagesCount || !app.getCustomer().isLogged()) ? 1:0
                    };
                view.$('.cart-advantages').attr(advantagesAttr).data(advantagesAttr);
                view.$('.cart-advantages .badge').text(advantagesCount);
            },
            onChangeContext:function(cart){
                // TODO : Obsolète ou au mauvais endroit ?
                this.render();
            },
            updateCartQuantity:function(){
                this.$('.btn-show-all').text(app.t('Voir les %s produits de votre panier','Cart',app.getCart().getProducts().size()));
            },
            onAddProductIndispo: function (cartProduct) {
                this.addProductLine(cartProduct);
            },
            onAddProduct: function (cartProduct) {
                //
                // si c'est un consommable, on ne l'ajoute pas à la liste
                if(cartProduct.getProduct().isInCategorySlug('consumable')) return;
                //
                // si c'est le premier produit ajouté, on ne l'ajoute pas en double, le render suffira
                if(app.getCart().getProducts().size()===1) return;
                //
                this.addProductLine(cartProduct);
            },
            addProductLine:function(cartProduct){
                var view = this,
                    productLine = view.attachView(
                        new ProductLineView({cartProduct: cartProduct, format: 'mini', type: 'normal', editable:true})
                    );
                view.$('.cart-products-list').append(productLine.el);
                view.updateCartList();
            },

            updateCartList: function () {
                // console.log(event);
                var view = this,
                    showCart = view.$('.show-cart'),
                    showCartVirtualHeight = showCart.height()===0?24:0,
                    list = view.$('.cart-products-list'),
                    li = list.find('li'),
                    liLength = li.length,
                    listH = list.outerHeight(),
                    liH = li.outerHeight(),
                    difference = Math.max(app.get('winH') - view.$el.position().top - view.$('.cart').height() - showCartVirtualHeight + listH - 50, 0),
                    nbLiToShow = Math.floor(difference / liH);

                showCart.toggleClass('hide', liLength <= nbLiToShow);
                view.updateCartQuantity();

                li.each(function (index) {
                    $(this).toggleClass('inactive', index + 1 <= liLength - nbLiToShow);
                });


            },

            render: function () {
                var view = this,
                    cart = app.getCart(),
                    t = cartTemplate({
                        cart: cart,
                        app:app,
                    });

                view.$('.cart').html(t);
                view.$('.btn-order').html(view.templateSubmit());
                view.renderAdvantages();


                function AppendView(constructor,selector,options){
                    view.appendView(constructor,selector,options);
                }

                AppendView(CartVoucherPriceView,'.cart-voucher-total');
                AppendView(CartVoucherView,'.cart-voucher', {origin: 'listing'});
                AppendView(CartMinimumShippingPriceView,'.minimum-shipping-price');
                AppendView(CartExtraPriceView,'.cart-extra-price');
                AppendView(CartCagnotteView, '.cart-cagnotte');

                //
                // chaque ligne produit a une View
                //
                view.$('.product-line').each(function () {
                    AppendView(ProductLineView,this);
                });

                //view.onChangeContext(cart);
                //
                InternalLinkView.initializeLinksOfView(view);
                //
                view.delegateEvents();
                //
                // TODO pourquoi un setTimeout ?
                //
                setTimeout(function(){
                    view.updateCartList();
                    // debug
                    //view.openAdvantages();
                }, 1);

            },
            //openConsumableOptions: function () {
            //    app.displayModal(new ConsumableOptionsView());
            //},
            submitCart:function(e){
                var cart = app.getCart()
                cart.validateSubmitToCheckout();
                TagCommander.eventGA(e.currentTarget,'checkout','begin','Listing');
            },
            openAdvantages: function(e){
                var currentTarget = e.currentTarget;
                TagCommander.eventGA(currentTarget,"Panier","Voir les avantages",$(currentTarget).data('data-advantages-count'));
                function displayAdvantage(logged){
                    if(logged && app.getCart().getUsableAdvantages().length){
                        app.displayModal(new CartAdvantagesView({displayAsModal:true}));
                    }
                }
                app.getCart().requireAuthentification(displayAdvantage);
            },
            templateSubmit:function(){
                var model = this,
                    cart = app.getCart(),
                    price = cart.formatPrice(),
                    unavailable = cart.getProductsIndispo().size();
                return submitTemplate({
                    unavailable:unavailable,
                    price:price,
                    label: app.t('Voir le panier','Cart'),
                });
            },
        });
    });
